import { userRoles as ur } from "../data/userRole";
import AuctionDetails from '../components/AuctionAdmin/AuctionDetails';
import AuctionLiveCurrent from '../components/LiveAuction/AuctionLiveCurrent';
import AuctionLiveLots from '../components/LiveAuction/AuctionLiveLots';
import AuctionLiveRegistration from '../components/LiveAuction/AuctionLiveRegistration';

export const admin_routes = [
    {
        path: "/admin/AuctionInfos/:auctionID/details",
        ele: <AuctionDetails />,
        availability: [ur.admin, ur.superAdmin]
    },
    {
        path: "/admin/auctions/current",
        ele: <AuctionLiveCurrent />,
        availability: [ur.admin, ur.superAdmin]
    },
    {
        path: "/admin/auctions/current/:auctionID/livelots",
        ele: <AuctionLiveLots />,
        availability: [ur.admin, ur.superAdmin]
    },
    {
        path: "/admin/auctions/current/:auctionID/liveRegistration",
        ele: <AuctionLiveRegistration />,
        availability: [ur.admin, ur.superAdmin]
    },

]